import { Color, TextureLoader } from "three";
import { VBase } from "./VBase";
import VUtil from "../VUtils";
import { VButton } from "./_VButton.js";
import { VScrollViewVerticle } from "./_VScrollViewVerticle";
import { VText } from "./_VText.js";
import { VImage } from "./_VImage.js";

const defaultOptions = {
  options: ["选项1", "选项2", "选项3"],
  map: null,
  color: 0xffffff,
  opacity: 1.0,
  textSize: 0.04,
  textColor: 0xff0000,
  defaultIndex: 0,
  itemBgMap: null,
  itemColor: 0x3d4146,
  iconColor: 0x00ffff,
  bgColor: 0xffffff,
  bgOpacity: 0.5,
  width: 0.3,
  height: 0.1,
  radius: 0.01,
  outlineWidth: 0.001,
  orientation: "button",
  font: "normal",
  optionViewLength: 0,
  stateChangeImage: null,
  stateChangeColor: null,
  optionStageChangeImage: null,
  optionStageChangeColor: null,
  disabledColor: 0xc8c8c8,
  enabledCb: null,
};

/*
  使用案例

    const dropdownBgPath = "/assets/vrUI/measurePanel/dropdownBg.png";
      const dropdownItemBgPath = "/assets/vrUI/measurePanel/dropdownItemBg.png";
      const dropdownBg = await this.manager.loadManager.loadTexture(
        dropdownBgPath
      );
      const itemBg = await this.manager.loadManager.loadTexture(
        dropdownItemBgPath
      );

      const dropdown = this.uiLib.createDropdown({
        options: ["m", "cm", "mm"],
        defaultIndex: 0,
        map: dropdownBg,
        textSize: 0.06,
        textColor: 0xffffff,
        iconColor: 0xffffff,
        width: 0.25,
        height: 0.08,
        itemBgMap: itemBg,
        bgOpacity: 0,
        radius: 0,
        stateChangeColor: {
          normal: 0xffffff,
          hover: 0xafbbe3,
          click: 0x8993c3,
        },
        itemColor: 0x000000,
        optionViewLength:0.2,
        optionStageChangeColor: {
          normal: 0x000000,
          hover: 0xafbbe3,
        },
      });
      // 注册选项改变事件
      dropdown.addOnValueChangeEvent((index, str) => {
        console.log("当前选择的选项为" + str + "  索引为" + index);
      });

      this.uiLib.addUIToScene(dropdown);


*/
export class VDropdown extends VBase {
  /**
   * options:
   * {
   *      options: 按钮文字内容，默认为"按钮"
   *      priority: 优先级，默认为0，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99999
   *      map: 背景贴图，不是贴图地址，默认为null
   *      orientation: 选项显示在下面还是上面，默认为"button"."top"/"button"
   *      itemBgMap: 选项背景贴图，不是贴图地址，默认为null
   *      itemColor: 选项颜色，默认为0x00ffff
   *      iconColor: 图标颜色，默认为0x00ffff
   *      color: 按钮颜色。默认为 0xffffff
   *      opacity: 1,按钮背景透明度，默认为1
   *      textSize: 文字大小，默认为 0.03
   *      textColor: 文字颜色，默认为 0x000000
   *      defaultIndex: 默认选中的选项索引，默认为0
   *      bgColor: 选项背景颜色，默认为0xffffff
   *      bgOpacity: 选项背景透明度，默认为0.5
   *      width: 按钮宽度，默认为 0.2
   *      height: 按钮高度，默认为 0.1
   *      radius: 圆角半径，设为0则是矩形，默认为0.01
   *      font: 字体正常或粗体，"normal"-正常  "bold"-粗体 ，默认为"normal"
   *      outlineWidth: 文字描边宽度，默认为 0.001
   *      optionViewLength: 选项可视范围长度，默认为0，表示由选项数量决定
   *      stateChangeImage: 按钮状态改变时的贴图对象，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   *      stateChangeColor: 按钮状态改变时的颜色对象，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   *      optionStageChangeImage: 选项状态改变时的贴图对象，可以包含3个状态（"normal","hover"）也可以只设置其中某些状态,默认为null
   *      optionStageChangeColor: 选项状态改变时的颜色对象，可以包含3个状态（"normal","hover"）也可以只设置其中某些状态,默认为null
   *      disabledColor: ui对象禁用颜色，默认为 0xC8C8C8
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99999,
      priority: options.priority !== undefined ? options.priority : 0,
      options: options.options ? options.options : defaultOptions.options,
      defaultIndex:
        options.defaultIndex !== undefined
          ? options.defaultIndex
          : defaultOptions.defaultIndex,
      orientation: options.orientation
        ? options.orientation
        : defaultOptions.orientation,
      itemBgMap: options.itemBgMap
        ? options.itemBgMap
        : defaultOptions.itemBgMap,
      itemColor:
        options.itemColor !== undefined
          ? options.itemColor
          : defaultOptions.itemColor,
      map: options.map ? options.map : defaultOptions.map,
      bgColor:
        options.bgColor !== undefined
          ? options.bgColor
          : defaultOptions.bgColor,
      bgOpacity:
        options.bgOpacity !== undefined
          ? options.bgOpacity
          : defaultOptions.bgOpacity,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      iconColor:
        options.iconColor !== undefined
          ? options.iconColor
          : defaultOptions.iconColor,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      textSize:
        options.textSize !== undefined
          ? options.textSize
          : defaultOptions.textSize,
      textColor:
        options.textColor !== undefined
          ? options.textColor
          : defaultOptions.textColor,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
      outlineWidth:
        options.outlineWidth !== undefined
          ? options.outlineWidth
          : defaultOptions.outlineWidth,
      font: options.font ? options.font : defaultOptions.font,
      optionViewLength:
        options.optionViewLength !== undefined
          ? options.optionViewLength
          : defaultOptions.optionViewLength,
      stateChangeImage: options.stateChangeImage
        ? options.stateChangeImage
        : null,
      stateChangeColor: options.stateChangeColor
        ? options.stateChangeColor
        : null,
      optionStageChangeImage: options.optionStageChangeImage
        ? options.optionStageChangeImage
        : null,
      optionStageChangeColor: options.optionStageChangeColor
        ? options.optionStageChangeColor
        : null,
      disabledColor:
        options.disabledColor !== undefined
          ? options.disabledColor
          : defaultOptions.disabledColor,
    };

    if (!tempOptions.options || tempOptions.options.length === 0) {
      console.error("VDropdown error: options is empty");
      return;
    }
    if (
      tempOptions.defaultIndex < 0 ||
      tempOptions.defaultIndex >= tempOptions.options.length
    ) {
      console.warn("VDropdown error: defaultIndex is out of range,set to 0");
      tempOptions.defaultIndex = 0;
    }

    super(tempOptions, vuiLib);
    this._vType = "VDropdown";

    this._otherProps = {
      options: tempOptions.options,
      defaultIndex: tempOptions.defaultIndex,
      orientation: tempOptions.orientation,
      itemBgMap: tempOptions.itemBgMap,
      itemColor: tempOptions.itemColor,
      bgColor: tempOptions.bgColor,
      bgOpacity: tempOptions.bgOpacity,
      iconColor: tempOptions.iconColor,
      optionViewLength: tempOptions.optionViewLength,
      onValueChange: [],
      optionStageChangeImage: tempOptions.optionStageChangeImage,
      optionStageChangeColor: tempOptions.optionStageChangeColor,
    };

    this.selectIndex = tempOptions.defaultIndex;

    this.name = "VDropdown";

    this._createDefaultText(this.selectIndex);

    this.createIcon();

    // 滚动区域
    let height = 0;
    if (this._otherProps.optionViewLength > 0) {
      height = this._otherProps.optionViewLength;
    } else {
      height =
        this._otherProps.options.length > 4
          ? this._baseProps.height * 4
          : this._otherProps.options.length * this._baseProps.height;
    }
    this.scrollview = new VScrollViewVerticle(
      {
        renderOrder: this._baseProps.renderOrder + 10,
        width: this._baseProps.width,
        height: height,
        radius: this._baseProps.radius,
        color: this._otherProps.bgColor,
        opacity: this._otherProps.bgOpacity,
        sliderExitState: "hide",
      },
      this.vuilib
    );
    this.scrollview.addOnElementHoverEnterEvent((obj) => {
      this._onOptionHoverEnter(obj);
    });
    this.scrollview.addOnElementHoverExitEvent((obj) => {
      this._onOptionHoverExit(obj);
    });
    this.scrollview.hide();
    this.add(this.scrollview);
    if (this._otherProps.orientation === "top") {
      this.scrollview.position.y = (height + this._baseProps.height) / 2;
    } else {
      this.scrollview.position.y = -(height + this._baseProps.height) / 2;
    }
    this.scrollview.slider.position.x += this.scrollview.slider.height;

    this.optionBtns = [];
    // 所有选项文字
    for (var i = 0; i < this._otherProps.options.length; i++) {
      const btn = new VButton(
        {
          text: this._otherProps.options[i],
          map: this._otherProps.itemBgMap,
          color: this._otherProps.itemColor,
          opacity: 1,
          textSize: this._textProps.textSize,
          textColor: this._textProps.textColor,
          width: this._baseProps.width,
          height: this._baseProps.height,
          radius: this._baseProps.radius,
          outlineWidth: this._textProps.outlineWidth,
          font: this._textProps.font,
        },
        this.vuilib
      );
      btn.addClickEvent((obj) => {
        this._onClickOptionBtn(obj);
      });
      btn.addHoverEnterEvent(() => {});
      btn.addHoverExitEvent(() => {});
      btn._vIndex = i;
      this.scrollview.addContent(btn);
      this.optionBtns.push(btn);
    }

    this.width = this._baseProps.width;
    this.height = this._baseProps.height;
  }

  async createIcon() {
    this.openIcon = await new TextureLoader().loadAsync(
      "/assets/vrUILib/dropdown/open.png"
    );
    this.closeIcon = await new TextureLoader().loadAsync(
      "/assets/vrUILib/dropdown/close.png"
    );

    this.icon = new VImage(
      {
        map: this.openIcon,
        width: this._baseProps.height * 0.7,
        height: this._baseProps.height * 0.7,
        radius: 0,
        color: this._otherProps.iconColor,
      },
      this.vuilib
    );
    this.icon.position.z = 0.001;
    this.icon.position.x =
      this._baseProps.width / 2 - this._baseProps.height / 1.5;
    this.add(this.icon);
  }

  _onOptionHoverEnter(obj) {
    if (this._otherProps.optionStageChangeColor) {
      if (this._otherProps.optionStageChangeColor.hover !== undefined) {
        obj.material.color = new Color(
          this._otherProps.optionStageChangeColor.hover
        );
        VUtil.convertSRGBToLinear(obj.material);
      }
    }
    if (this._otherProps.optionStageChangeImage) {
      if (this._otherProps.optionStageChangeImage.hover) {
        obj.material.map = this._otherProps.optionStageChangeImage.hover;
      }
    }
  }

  _onOptionHoverExit(obj) {
    if (this._otherProps.optionStageChangeColor) {
      if (this._otherProps.optionStageChangeColor.normal !== undefined) {
        obj.material.color = new Color(
          this._otherProps.optionStageChangeColor.normal
        );
        VUtil.convertSRGBToLinear(obj.material);
      }
    }
    if (this._otherProps.optionStageChangeImage) {
      if (this._otherProps.optionStageChangeImage.normal) {
        obj.material.map = this._otherProps.optionStageChangeImage.normal;
      }
    }
  }

  _createDefaultText(index) {
    if (this.defaultText) {
      this.defaultText.clear();
      this.defaultText = null;
    }

    // 默认选项文字
    this.defaultText = new VText({
      text: this._otherProps.options[index],
      textSize: this._textProps.textSize,
      textColor: this._textProps.textColor,
      font: this._textProps.font,
      outlineWidth: this._textProps.outlineWidth,
      align: "left",
    });
    this.add(this.defaultText);
    this.defaultText.position.z = 0.001;
    this.defaultText.position.x = -this._baseProps.width / 2 + 0.025;
  }

  _onClickOptionBtn(btn) {
    const index = btn._vIndex;

    this._createDefaultText(index);

    this.scrollview.setSliderValue(0);
    this.scrollview.hide();

    if (this.selectIndex !== index) {
      this.selectIndex = index;

      for (var i = 0; i < this._otherProps.onValueChange.length; i++) {
        this._otherProps.onValueChange[i](
          index,
          this._otherProps.options[index]
        );
      }
    }

    if (this.icon) {
      this.icon.material.map = this.openIcon;
    }
  }

  onSelectEnd(obj) {
    if (!this._otherProps || !this._baseProps.enabled) return;

    if (this.scrollview.visible) {
      this.scrollview.hide();
      this.icon.material.map = this.openIcon;
    } else {
      this.scrollview.show();
      if (this.icon) {
        this.icon.material.map = this.closeIcon;
      }
    }

    super.onSelectEnd(obj);
  }

  getClickable() {
    let res = [];
    if (!this.visible || !this._baseProps.enabled) return res;
    res.push(this);
    if (this.scrollview.visible) {
      res = res.concat(this.optionBtns);
    }
    return res;
  }

  /**
   * 增加一个回调函数，当value改变调用，参数为当前选中选项的索引及选项文字
   * @param {*} fun
   * @returns
   */
  addOnValueChangeEvent(fun) {
    if (!fun) return;
    this._otherProps.onValueChange.push(fun);
  }

  /**
   * 移除一个 当value改变调用 的回调函数，参数为当前选中选项的索引及选项文字
   * @param {*} fun
   * @returns
   */
  removeOnValueChangeEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onValueChange.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onValueChange.splice(index, 1);
    }
  }

  /**
   * 移除所有 当value改变调用 的回调函数
   */
  removeAllOnValueChangeEvent() {
    this._otherProps.onValueChange = [];
  }
}
